import React from 'react';

const SettingsProfile = ({ userData }) => (
  <form className="box box--has-border" action="#">
    <div className="form-group">
      <label>Current Password</label>
      <input
        type="text"
        required
        name="current-password"
        placeholder="Current Password"
        autoComplete="current-password"
      />
    </div>
    <div className="form-group">
      <label>New Password</label>
      <input
        type="text"
        required
        name="new-password"
        placeholder="New Password"
        autoComplete="new-password"
      />
    </div>
    <div className="form-group">
      <label>Repeat New Password</label>
      <input
        type="text"
        required
        name="repeat-new-password"
        placeholder="Repeat New Password"
        autoComplete="new-password"
      />
    </div>
    <button className="btn-primary is-block" type="submit">
      Save
    </button>
  </form>
);

export default SettingsProfile;
